import './style.scss';
import { Compton } from './models/compton';
import { IAnswer } from './models/answer';

window.addEventListener('DOMContentLoaded', () => {
  const actions = document.querySelectorAll<HTMLAnchorElement>('a.mb-compton');

  actions.forEach(action => {
    action.addEventListener('click', async e => {
      e.preventDefault();
      const answers: IAnswer[] = [];

      const inputs = document.querySelectorAll('label.ECM_CheckboxInput');
      inputs.forEach(input => {
        const checkbox = input.querySelector<HTMLInputElement>('.ECM_CheckboxInput-Input');
        const name = checkbox?.name || '';
        const dummyInput = input?.querySelector<HTMLSpanElement>('.ECM_CheckboxInput-DummyInput');
        if (!dummyInput) {
          return;
        }
        const before = getComputedStyle(dummyInput, '::before');
        const isChecked = before.backgroundColor === 'rgb(255, 255, 255)';
        const labelText = input.querySelector<HTMLSpanElement>('.ECM_CheckboxInput-LabelText')?.textContent || '';

        answers.push({
          name,
          isChecked,
          labelText,
        });
      });

      const url = window.location.href;
      const compton = new Compton();
      const response = await compton.answer({ url, answers });
      window.location.href = action.href;
    });
  });
});
